import { HttpClient } from "@angular/common/http";
import { Injectable, ViewChild } from "@angular/core";
import { AlertController, App, Events, Nav } from "ionic-angular";
import { MposProvider } from "../mpos/mpos";
import { LoadingProvider } from "../loading/loading";
import { RequestServiceProvider } from "../request-service/request-service";
import { TransactionAlertProvider } from "../transaction-alert/transaction-alert";
declare var result;

/*
  Generated class for the PinPadProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

interface alertable {
  name: string;
  title: string;
  message: string;
  actionName: string;
  action(): any;
  backdrop: boolean;
  popUp: boolean;
}

@Injectable()
export class PinPadProvider {
  constructor(
    public app: App,
    public http: HttpClient,
    protected alertCtrl: AlertController,
    protected mpos: MposProvider,
    public events: Events,
    private load: LoadingProvider,
    private request: RequestServiceProvider,
    private transAlert: TransactionAlertProvider
  ) {}

  makeAlert(item: alertable) {
    const options = {
      title: item.title,
      cssClass: "ready-alert",
      message: item.message,
      buttons: [
        {
          text: item.actionName,
          cssClass: "cta",
          handler: () => {
            item.action();
          }
        }
      ],
      enableBackdropDismiss: item.backdrop
    };
    if (!item.popUp) {
      options.buttons[0].handler();
    } else {
      this.alertCtrl.create(options).present();
    }
    // return this.alertCtrl.create(options);
    // alert.present()
  }

  notConnectedAlert(link) {
    const alert = this.alertCtrl.create({
      title: "",
      cssClass: "ready-alert",
      message: `
               <img src="../../assets/img/radio.svg" width="40" alt="image">
                <h5>No Pinpad Connected</h5>
                <br>
                Your device has not been linked to any device, click on the "Link Terminal"
                button to continue.
              `,
      buttons: [
        {
          text: "Cancel",
          cssClass: "cta outline",
          handler: () => {}
        },
        {
          text: "Connect",
          cssClass: "cta",
          handler: () => {
            link();
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  pinPadConnectList(devices) {
    const alert = this.alertCtrl.create({
      title: "",
      cssClass: "ready-alert",
      message: `
             <h5>Loading Connected Devices...</h5>
             <p id="device"></p>
              `,
      buttons: [
        {
          text: "Cancel",
          cssClass: "cta outline"
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  loading(message) {
    return this.alertCtrl.create({
      title: "",
      cssClass: "ready-alert",
      message: `<h5>${message}</h5>`,
      buttons: [{}],
      enableBackdropDismiss: false
    });
  }

  deviceList(devices) {
    // let registered = true, regAddress;
    const options = {
      title: "Select Pinpad for Linking",
      buttons: [
        {
          text: "Continue",
          cssClass: "cta",
          handler: ({ name, address }) => {
            let navTransition = alert.dismiss();
            this.load.presentLoading("Connecting...");
            const data = {
              agent_code: localStorage.getItem("agentCode"),
              serial: name
            };
            this.request.postCheckLinkedPinPad(data).subscribe(
              (response: any) => {
                this.load.loader.dismiss().catch(() => {});
                if (response.status === 1) {
                  window.localStorage.setItem("mposName", name);
                  navTransition.then(() => {
                    this.connectToBluetooth(name, address);
                    this.app.navPop();
                  });
                } else if (response.status === 0) {
                  this.registerPinPad(name);
                } else {
                  //Terminal does not belong to agent
                  this.transAlert.presentNormalErrorAlert("Pinpad does not belong to agent");
                }
              },
              error => {
                this.load.loader.dismiss().catch(() => {});
                this.transAlert.presentNormalErrorAlert(error.error.message);
                if (error.json().code === 403) {
                  this.request.logout();
                }
              }
            );
            return false;
          }
        }
      ],
      inputs: []
    };
    // Now we add the radio buttons
    let deviceToUsedOutside, name;
    if (Array.isArray(devices)) {
      name = window.localStorage.getItem("mposName");
      devices.forEach(device => {
        const bluetoothDevice = {
          name: "options",
          value: device,
          label: device.name,
          type: "radio"
        };
        if (device.name === name) {
          deviceToUsedOutside = device;
          bluetoothDevice["checked"] = true;
        }
        options.inputs.push(bluetoothDevice);
      });
    }
    // Create the alert with the options
    let alert = this.alertCtrl.create(options);
    if (name) {
      options.buttons[0].handler(deviceToUsedOutside);
    } else {
      alert.present();
    }
  }

  registerPinPad(terminalId) {
    const alert = this.alertCtrl.create({
      title: "",
      cssClass: "ready-alert",
      message: `
                <img src="../../assets/img/radio.svg" width="40" alt="image">
                <h5>Link Agent ID with Pinpad</h5>
                <br>
                Your device has not been linked to any device, click on the "Link Button"
                button to continue.
              `,
      buttons: [
        {
          text: "Link Pin Pad",
          cssClass: "cta",
          handler: () => {
            const data = {
              agent_code: localStorage.getItem("agentCode"),
              serial: terminalId
            };
            this.request.postPinpadLinking(data).subscribe(
              response => {
                const message = response.desc || "Pin pad linked successfully";
                this.transAlert.presentNormalSuccessAlert(message);
              },
              error => {
                //console.log(error);
                if (error.json().code === 403) {
                  this.request.logout();
                }
                this.transAlert.presentNormalErrorAlert(error.message);
              }
            );
          }
        }
      ],
      enableBackdropDismiss: false
    });
    alert.present();
  }

  private async connectToBluetooth(name, address) {
    const mac = `${name}(${address})`;
    await this.mpos.connectBluetoothDevice(
      data => {
        console.log(result);
      },
      error => {
        console.log(error);
      },
      true,
      mac
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/pin-pad/pin-pad.ts